"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _classnames = _interopRequireDefault(require("classnames"));

var _insidedDataStorage = require("@insided/shared/utils/insidedDataStorage");

var _phrase = _interopRequireDefault(require("@insided/deprecated-libs/translationsUtils/phrase"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var DEFAULT_BOTTOM_OFFSET = 48;
var DEFAULT_MAX_HEIGHT = 500;

var NotificationCenterFloatingPanel = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(NotificationCenterFloatingPanel, _Component);

  var _super = _createSuper(NotificationCenterFloatingPanel);

  function NotificationCenterFloatingPanel(props) {
    var _this;

    (0, _classCallCheck2.default)(this, NotificationCenterFloatingPanel);
    _this = _super.call(this, props);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "floatingPanelRef", (0, _preact.createRef)());
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "listRef", (0, _preact.createRef)());
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onClickOutside", function (e) {
      var _this$floatingPanelRe, _this$props$triggerRe;

      var isPanel = (_this$floatingPanelRe = _this.floatingPanelRef.current) === null || _this$floatingPanelRe === void 0 ? void 0 : _this$floatingPanelRe.contains(e.target);
      var isTrigger = (_this$props$triggerRe = _this.props.triggerRef) === null || _this$props$triggerRe === void 0 ? void 0 : _this$props$triggerRe.contains(e.target);

      if (!isPanel && !isTrigger) {
        _this.props.closeNotificationPanel();
      }
    });
    _this.state = {
      panelMaxHeight: DEFAULT_MAX_HEIGHT
    };
    _this.setPanelMaxHeight = _this.setPanelMaxHeight.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(NotificationCenterFloatingPanel, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      document.addEventListener('mousedown', this.onClickOutside);
      var isClient = (typeof window === "undefined" ? "undefined" : (0, _typeof2.default)(window)) === 'object';
      var isMobile = isClient && (0, _insidedDataStorage.getInsidedData)('device') === 'mobile';
      window.addEventListener('resize', this.setPanelMaxHeight);

      if (isMobile && this.floatingPanelRef.current) {
        this.floatingPanelRef.current.style.maxWidth = 'calc(100vw - 16px)';
        this.floatingPanelRef.current.style.left = 'unset';
        this.floatingPanelRef.current.style.right = '0';
        this.floatingPanelRef.current.style.transform = 'translateX(40px)';
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(previousProps) {
      if (previousProps.isOpen !== this.props.isOpen && this.props.isOpen) {
        var _this$listRef$current;

        this.setPanelMaxHeight();
        (_this$listRef$current = this.listRef.current) === null || _this$listRef$current === void 0 ? void 0 : _this$listRef$current.scrollTo({
          top: 0
        });
      }
    }
  }, {
    key: "setPanelMaxHeight",
    value: function setPanelMaxHeight() {
      var _this$floatingPanelRe2;

      var viewportOffset = (_this$floatingPanelRe2 = this.floatingPanelRef.current) === null || _this$floatingPanelRe2 === void 0 ? void 0 : _this$floatingPanelRe2.getBoundingClientRect();

      if (this.floatingPanelRef.current && viewportOffset !== null && viewportOffset !== void 0 && viewportOffset.top) {
        this.setState({
          panelMaxHeight: window.innerHeight - viewportOffset.top - DEFAULT_BOTTOM_OFFSET
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.removeEventListener('mousedown', this.onClickOutside);
      window.removeEventListener('resize', this.setPanelMaxHeight);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          isOpen = _this$props.isOpen,
          children = _this$props.children,
          markAllAsRead = _this$props.markAllAsRead,
          isSomeNotificationsUnread = _this$props.isSomeNotificationsUnread;
      var panelMaxHeight = this.state.panelMaxHeight;
      return (0, _preact.h)("div", {
        className: (0, _classnames.default)('notification-center__panel', {
          'is-open': isOpen
        }),
        ref: this.floatingPanelRef,
        style: {
          maxHeight: "".concat(panelMaxHeight, "px")
        }
      }, (0, _preact.h)("div", {
        className: "notification-center__panel__header"
      }, (0, _preact.h)("div", {
        className: "notification-center__panel__header__title"
      }, (0, _preact.h)(_phrase.default, {
        p: "notification.center.information.notifications"
      })), isSomeNotificationsUnread ? (0, _preact.h)("div", {
        className: "notification-center__panel__header__all-read",
        role: "button",
        onClick: markAllAsRead,
        "data-track-type": "click",
        "data-element-name": "Notification Center Mark All As Read"
      }, (0, _preact.h)(_phrase.default, {
        p: "notification.center.markAllRead"
      })) : null), (0, _preact.h)("div", {
        className: "notification-center__panel__list",
        ref: this.listRef
      }, children));
    }
  }]);
  return NotificationCenterFloatingPanel;
}(_preact.Component);

var _default = NotificationCenterFloatingPanel;
exports.default = _default;